
import React from 'react';
import { IKContext, IKUpload } from 'imagekitio-react';
import { FaUpload } from 'react-icons/fa';

const ImageKitUpload = ({ onUploadSuccess, onUploadError }) => {
    const publicKey = "your_public_key";
    const urlEndpoint = "https://ik.imagekit.io/your_imagekit_id";

    const authenticator = async () => {
        try {
            const response = await fetch('http://localhost:5000/api/imagekit-auth');

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Request failed with status ${response.status}: ${errorText}`);
            }

            const data = await response.json();
            const { signature, expire, token } = data;
            return { signature, expire, token };
        } catch (error) {
            throw new Error(`Authentication request failed: ${error.message}`);
        }
    };

    return (
        <IKContext publicKey={publicKey} urlEndpoint={urlEndpoint} authenticator={authenticator}>
            <label htmlFor="file-upload" className="custom-file-upload">
                <FaUpload /> Custom Upload
            </label>
            <IKUpload
                id="file-upload"
                onError={onUploadError}
                onSuccess={onUploadSuccess}
                style={{ display: 'none' }}
            />
        </IKContext>
    );
};

export default ImageKitUpload;
